import { STATUS_TYPES } from '_atoms/Status';
import type { StatusType } from '_atoms/Status';

export const OPENING_STATUSES = {
  SH_APPROVAL: 'Pending SH approval',
  RM_APPROVAL: 'Pending RM approval',
  LM_APPROVAL: 'Pending LM approval',
  HRL_APPROVAL: 'Pending HRL approval',
  RM_REAPPROVAL: 'Pending RM reapproval',
  LM_REAPPROVAL: 'Pending LM reapproval',
  OPEN: 'Open',
  WAITING_FOR_ENTRY: 'Waiting for entry',
  ON_HOLD: 'On hold',
  DECLINED: 'Declined',
  HIRED: 'Hired',
  CLOSED: 'Closed',
} as const;

export type OpeningStatus = (typeof OPENING_STATUSES)[keyof typeof OPENING_STATUSES];

export const OPENING_STATUSES_SHORT = {
  OPEN: 'Open',
  PENDING_APPROVAL: 'Pending approval',
  PENDING_REAPPROVAL: 'Pending reapproval',
  WAITING_FOR_ENTRY: 'Waiting for entry',
  CLOSED: 'Closed',
} as const;

export type OpeningStatusShort = (typeof OPENING_STATUSES_SHORT)[keyof typeof OPENING_STATUSES_SHORT];

export const OPENING_STATUS_TYPES: Record<string, StatusType> = {
  [OPENING_STATUSES.SH_APPROVAL]: STATUS_TYPES.BLUE,
  [OPENING_STATUSES.RM_APPROVAL]: STATUS_TYPES.BLUE,
  [OPENING_STATUSES.LM_APPROVAL]: STATUS_TYPES.BLUE,
  [OPENING_STATUSES.HRL_APPROVAL]: STATUS_TYPES.BLUE,
  [OPENING_STATUSES.RM_REAPPROVAL]: STATUS_TYPES.BLUE,
  [OPENING_STATUSES.LM_REAPPROVAL]: STATUS_TYPES.BLUE,
  [OPENING_STATUSES.OPEN]: STATUS_TYPES.GREEN,
  [OPENING_STATUSES.WAITING_FOR_ENTRY]: STATUS_TYPES.YELLOW,
  [OPENING_STATUSES.ON_HOLD]: STATUS_TYPES.GRAY,
  [OPENING_STATUSES.CLOSED]: STATUS_TYPES.GRAY,
  [OPENING_STATUSES.HIRED]: STATUS_TYPES.GREEN,
  [OPENING_STATUSES.DECLINED]: STATUS_TYPES.RED,
};
